import ThreeDViewComponent from "../../Components/ThreeDViewer";
import DateSlider from "../../Components/DateSlider";
import CorridorDropDown from "../../Components/CorridorDropDown";
import React, {useEffect, useRef, useState} from "react";
import { useAuthState } from '../../Context/context';
import {Box, Center, } from "@chakra-ui/react";
import { Stack, HStack, VStack } from '@chakra-ui/react'
import { Spacer, Heading, } from '@chakra-ui/react'
import { Radio, RadioGroup, Select } from '@chakra-ui/react'
import getConf from "../../services/corridorConf"
import loadCorridors from "../../services/viewerFuncs/getCorridors";
import {useParams} from 'react-router-dom'
import loadCorrDates from "../../services/viewerFuncs/getDates";



function ThreeDViewer(props) {
    const {datasetP, leftDateP, viewTypeP, rightDateP} = useParams()
    const userDetails = useAuthState()
    let dataset = useRef(datasetP);
    let availDates = useRef([])
    let [viewType, setViewType] = useState(viewTypeP)
    let [leftDate, setLeftDate] = useState(leftDateP)
    let [rightDate, setRightDate] = useState(rightDateP)
    let corridorList = useState(loadCorridors())
    console.log(corridorList)

    const fetchDates = (corridor) =>{
        let response = loadCorrDates(corridor)
            .then((response) =>{
                return response
            })
            .catch((error) =>{
            })
        return response
    }

    const chooseDataset = async (e) =>{
        dataset.current = e.target.value
        availDates.current= await fetchDates(dataset.current)
        setLeftDate(availDates.current[0])
        setRightDate(availDates.current[availDates.current.length-1])
    }

    const chooseViewType = (e) =>{
        setViewType(e)
        console.log(`avail dates on type change: ${JSON.stringify(availDates.current)}`)
        console.log(typeof(availDates.current))
        //if (dataset.current !== undefined && availDates.current === undefined){
        //    availDates.current = fetchDates(dataset.current)
        //}
    }

    const chooseLeftDate = (e) =>{
        setLeftDate(e.target.value)
    }

    const chooseRightDate = (e) =>{
       setRightDate(e.target.value)
    }

    useEffect(() => {
        console.log(availDates)
        if ((dataset.current !== undefined && viewType === '1' && leftDate !== undefined) ||
            (dataset.current !== undefined && viewType === '2' && leftDate !== undefined && rightDate !== undefined) ||
            viewType === '4' || viewType === '5'){
            ThreeDViewComponent(dataset.current, true, leftDate, rightDate, viewType, userDetails.token, availDates)
            if (rightDate === undefined){
                window.history.pushState("", "", `/3DViewer/${dataset.current}/${leftDate}/${viewType}/`);
            } else {
                window.history.pushState("", "", `/3DViewer/${dataset.current}/${leftDate}/${viewType}/${rightDate}`);
            }

        } else {
            return
        }
    }, [viewType, leftDate, rightDate, userDetails]);

    return (
        <Center w={"100%"} id={"test"}>
            <VStack w={"100%"}>
                 <Box w={"80%"}>
                    <Center><Box>
                        {/*<Button size='sm' onClick={(value) => optChange(value)}>{collapseOpts}</Button>*/}
                    </Box>
                        <Box p='2'>
                            <Heading size='md'>Model Viewer Options</Heading>
                        </Box>
                    </Center>
                    <Spacer  h={'5px'}  />
                    <Center>
                        <Box>
                            <Stack spacing={3}>
                                    <CorridorDropDown dataset={dataset.current} chooseDataset={chooseDataset}></CorridorDropDown>

                            </Stack>
                        </Box>
                    </Center>
                    <Spacer h={'5px'} />
                    {dataset.current !== undefined &&
                        <Center>
                                <RadioGroup defaultValue={viewType === undefined ?  ("3"):(viewType.current)} onChange={(value) => chooseViewType(value)}>
                                    <HStack spacing="24px">
                                        <Box w="205px" h="40px">
                                            <Radio value='1'>Timeline</Radio>
                                        </Box>
                                        <Box w="205px" h="40px">
                                            <Radio value='2'>Side-by-Side Comparison</Radio>
                                        </Box>
                                    </HStack>
                                </RadioGroup>
                        </Center> }
                    {viewType === '2' &&
                        <Center>
                            <HStack spacing="24px">
                                <Box w="200px" h="40px">
                                    <Select placeholder={leftDate === undefined ?  ("Left Date"):(leftDate)} onChange={(value) => chooseLeftDate(value)}>
                                        {availDates.current.map(function (date) {
                                            return <option value={date}>
                                                {date}
                                            </option>

                                        })
                                        }
                                    </Select>
                                </Box>
                                <Box w="200px" h="40px"><Select placeholder={rightDate === undefined ?  ("Right Date"):(rightDate)} onChange={(value) => chooseRightDate(value)}>
                                    {availDates.current.map(function (date) {
                                        return <option value={date}>
                                            {date}
                                        </option>
                                    })
                                    }
                                </Select>
                                </Box>
                            </HStack>
                        </Center>}
                    {viewType === '1' &&
                        <Center w={"100%"}>
                            <DateSlider dataset={dataset.current}></DateSlider>
                            <Spacer h="5px"/>
                        </Center>
                    }
                </Box>
                {/*<Box w={"100%"} h={"10%"}>*/}
                <Spacer />
                <div id="threeDViewer">{viewType === '2' && <div id="swipeSlide"></div>}
                </div>
                <div id="htmlOverlay">EXPERIMENTAL</div>
                {/*} </Box>*/}
            </VStack>
    </Center>
    )
}
export default ThreeDViewer;
